import Box from '@redbubble/design-system/src/Box';
import * as constants from '@redbubble/design-system/src/constants';
import Input from '@redbubble/design-system/src/Form/Input';
import Stack from '@redbubble/design-system/src/Stack';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { ChangeEvent } from 'react';
import { LocalisableLink } from '../LocalisableLink';

export const messages = defineMessages({
  prompt: {
    defaultMessage: 'I would like to receive offers and new arrivals by email.',
  },
  disclaimer: {
    defaultMessage: 'You may unsubscribe anytime. <link>Privacy Policy</link>',
  },
});

const privacyPolicyUrl = '/privacy';

const inputName = 'special-offers';

interface MarketingOptInProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  textAlign?: typeof constants.LEFT | typeof constants.CENTER;
}

export const MarketingOptIn = ({
  checked,
  onChange,
  textAlign,
}: MarketingOptInProps) => {
  const intl = useIntl();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <Box>
      <label>
        <Stack direction={constants.HORIZONTAL} spacing="s" alignItems="center">
          <Input
            type="checkbox"
            name={inputName}
            checked={checked}
            onChange={handleChange}
          />
          <Text type="display5">{intl.formatMessage(messages.prompt)}</Text>
        </Stack>
      </label>
      <Box marginTop="xs" textAlign={textAlign}>
        <Text type="caption">
          {intl.formatMessage(messages.disclaimer, {
            link: LocalisableLink(
              privacyPolicyUrl,
              undefined,
              constants.PRIMARY,
              true
            ),
          })}
        </Text>
      </Box>
    </Box>
  );
};
